import { render, staticRenderFns } from "./InventmentTarget.vue?vue&type=template&id=3f6a6b0e&scoped=true"
import script from "./InventmentTarget.vue?vue&type=script&lang=js"
export * from "./InventmentTarget.vue?vue&type=script&lang=js"
import style0 from "./InventmentTarget.vue?vue&type=style&index=0&id=3f6a6b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a6b0e",
  null
  
)

export default component.exports